import { useAuth0 } from "@auth0/auth0-react";
import CircularProgress from "@mui/material/CircularProgress";
import PastoralService from "Lib/API/PastoralApi/index.js";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import EventDrawerList from "./EventDrawerList";
import EventDrawerTabs from "./EventDrawerTabs";
import "./styles.scss";

const EventsDrawer = ({ name, eventData, callEventsTypeAgain, openMemberEventDrawer}) => {
	const { getAccessTokenSilently } = useAuth0();
	const [toggle, setToggle] = useState("1");
	const [loading, setLoading] = useState(true);
	const [events, setEvents] = useState({
		todayList: [],
		pasList: [],
		upcomingList: [],
    archivedList: [],
	});




	const getEventsHandler = async () => {
		const token = await getAccessTokenSilently();
		setLoading(true);
		PastoralService.getEventsByEventTypeId({ token, eventTypeId: eventData?.typeId })
			.then((res) => {
				if (res) {
					const { past, upcoming, today,archived } = res?.data || {};
					setEvents({
						todayList: today,
						pasList: past,
						upcomingList: upcoming,
            archivedList: archived,
					});
				}
			})
			.catch((err) => {
				toastr.error("Error", err?.data?.message || "Something went wrong");
			})
			.finally(() => {
				setLoading(false);
			});
	};

	useEffect(() => {
		getEventsHandler();
	}, [callEventsTypeAgain]);

	const activeList = {
		1: events?.todayList,
		2: events?.pasList,
		3: events?.upcomingList,
    4: events?.archivedList,
	};

	return (
		<div className="events-drawer p-12">
			<div className="events-drawer-h d-flex justify-content-between align-items-center py-3">
				<h2 className="m-0 font-weight-bold eventsDrawerHeading">{name}</h2>
			</div>
			<EventDrawerTabs toggle={toggle} setToggle={setToggle} />
			{loading ? (
				<div className="d-flex justify-content-center pt-20">
					<CircularProgress  />
				</div>
			) : (
				<EventDrawerList eventsList={activeList[toggle]} handelSelectEventMember={openMemberEventDrawer} />
			)}
		</div>
	);
};

export default EventsDrawer;
